import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { PostHogProvider } from 'posthog-js/react'

const isDev = process.env.NODE_ENV === 'development';

const options = {
  api_host: process.env.REACT_APP_PUBLIC_POSTHOG_HOST,
  loaded: (posthog: { opt_out_capturing: () => void }) => {
    if (isDev) posthog.opt_out_capturing();
  },
}


const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);
root.render(
  // 
    <PostHogProvider apiKey={process.env.REACT_APP_PUBLIC_POSTHOG_KEY || 'ph-test'} options={options}>
    {/* <React.StrictMode> */}
      <App />
    {/* </React.StrictMode> */}
    </PostHogProvider>
  // </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();

